import { Empty } from 'antd';
import { EmptyIcon } from 'assets/icon/bigicon';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import _ from 'underscore';
import { deleteEvent, fetchEvents } from 'state/actions/event';
import EventCards from 'design-components/EventCards';
import ModalPreview from 'components/ModalPreview';
import { CircularProgress } from '@material-ui/core';
import ModalDelete from 'components/ModalDelete';
import { FilterIcon } from 'assets/icon';
import CategoryDropdown from 'components/CategoryDropdown';
import { setTabEvent } from 'state/actions/breadcrumb';
import { filterAccess } from 'components/Report/utils';
import ModalCodeBlock from 'components/ModalCodeBlock';
import './Events.css';

function Events({ history }) {
  const [search, setSearch] = useState();
  const [modalPreview, setModalPreview] = useState({ isOpen: false, data: {} });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, event: null });
  const [typeOpen, setTypeOpen] = useState(false);
  const [selectedType, setSelectedType] = useState('all');
  const [tempSelectedType, setTempSelectedType] = useState(selectedType);
  const { siteId, siteName } = useParams();

  const { eventList, loading, selectedTab, userData,poisList } = useSelector(
    (state) => ({
      eventList: state.events.list,
      loading: state.events.loading,
      userData: state.auth.userData,
      selectedTab: state.breadcrumb.event,
      poisList: state.pois.list,
    }),
    shallowEqual
  );


  const dispatch = useDispatch();
    const [modalCode, setModalCode] = useState({ isOpen: false, data: {} });

  useEffect(() => {
    dispatch(fetchEvents({ siteId, type: selectedTab }));
  }, [siteId, selectedTab, dispatch]);

  const sourceTypes = [
    { _id: 'scape-api', name: 'Scape API' },
    { _id: 'manual', name: 'Adsign' },
  ];

  const getType = (type) => {
    if (type === 'all') {
      return 'Show All';
    }
    const findType = sourceTypes.find((t) => t._id === type);
    return findType?.name;
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDeleteEvent = () => {
    dispatch(
      deleteEvent({ id: deleteModal.event, siteId }, () => {
        setDeleteModal({ isOpen: false, event: null });
      })
    );
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/event/${id}`);
  };

  const onRemoveButtonClickHandler = (event) => {
    setDeleteModal((prevState) => ({
      event,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ event: null, isOpen: false });
  };

  const handleSetType = () => {
    setSelectedType(tempSelectedType);
    setTypeOpen(false);
  };

  const onTabClicked = (value) => {
    dispatch(setTabEvent(value));
  };

  const dataBySource = eventList.filter((event) => {
    if (selectedType === 'all') return true;
    if (selectedType === 'scape-api') return event.source === 'scape-api';
    if (selectedType === 'adobe-aem') return !event.source || event.source === 'adobe-aem';
    return true;
  });

  const filteredData = search
    ? dataBySource.filter((el) => {
        return el.name?.toLowerCase().includes(search.toLowerCase());
      })
    : dataBySource;



  return (
    <div className="media-library">
      <ModalPreview
        isVisible={modalPreview.isOpen}
        data={modalPreview.data}
        title="Preview Event"
        onCancel={() => {
          setModalPreview({ isOpen: false, data: {} });
        }}
      />
      <ModalCodeBlock
            isVisible={modalCode.isOpen}
            data={modalCode.data}
            title="Raw Data Events"
            onCancel={() => {
              setModalCode({ isOpen: false, data: {} });
            }}
      />
      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={handleDeleteEvent}
        onCancel={onCloseModalHandler}
        title="Delete Event"
        subtitle={deleteModal.event?.name}
        loading={loading}
      />

      <div className="media-header">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {filterAccess({
            userData,
            siteId,
            param: 'event',
            action: 'create',
          }) && (
            <Link
              to={`/${siteId}/information/${siteName}/event/new`}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              New Event
            </Link>
          )}
        </div>
      </div>

      <div className="media-header">
        <div className="media-header-left">
          <div
            className="playlist-wrapper"
            onClick={() => !loading && setTypeOpen(!typeOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>{getType(selectedType)}</span>
            </div>
            <i
              className={`feather-chevron-down ${
                typeOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={sourceTypes}
              modalOpen={typeOpen}
              handleSetPlaylist={handleSetType}
              setTempSelectedCategory={(id) => setTempSelectedType(id)}
              tempSelectedCategory={tempSelectedType}
              filter
              title="Source"
            />
          </div>
        </div>
      </div>
      <div className="media-content-wrapper">
        <div className="media-content">
          <div className="media-tab-wrapper">
            <div className="media-tab-left">
              <div
                onClick={() => onTabClicked('published')}
                className={`media-tab ${
                  selectedTab === 'published' ? 'active' : ''
                }`}
              >
                Active Events
              </div>
              <div
                onClick={() => onTabClicked('unpublished')}
                className={`media-tab ${
                  selectedTab === 'unpublished' ? 'active' : ''
                }`}
              >
                Unpublished Events
              </div>
            </div>
            Showing {filteredData.length} of {eventList.length} results
          </div>
          <div className="media-list-content">
            {loading && (
              <div className={'media-empty'}>
                <CircularProgress />
              </div>
            )}
            {!loading && filteredData.length > 0
              ? _.chunk(filteredData, 3).map((chunk, index) => {
                  return (
                    <div className="media-list-chunk" key={index}>
                      {chunk.map((event) => {
                        return (
                          <div
                            key={event._id}
                            data-id={event._id}
                            className="media-list"
                          >
                            <EventCards
                              data={event}
                              isShowMedia
                              editAction={() => handleEdit(event._id)}
                              deleteAction={() =>
                                onRemoveButtonClickHandler(event._id)
                              }
                              previewAction={() =>
                                setModalPreview({ isOpen: true, data: event })
                              }
                              dataAction={() =>
                              setModalCode({ isOpen: true, data: event })
                            }
                            isPreviewJSON
                            poiList={poisList}
                            />
                          </div>
                        );
                      })}
                      {chunk.length < 2 && <div className="media-list-empty" />}
                      {chunk.length < 3 && <div className="media-list-empty" />}
                    </div>
                  );
                })
              : !loading && (
                  <div className="media-empty">
                    <Empty image={<EmptyIcon />} description="No Event" />
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;